
export interface ChipsType {
  label: string;
  active: boolean;
}

export interface ChipsCategories {
  selectedChip: string;
  chipCategories: ChipsType[];
}

export const chipsConfig: ChipsCategories = {
  selectedChip: '',
  chipCategories: [
    {
      label: 'new',
      active: false
    },
    {
      label: 'popular',
      active: false
    },
    {
      label: 'slots',
      active: false
    },
    {
      label: 'live',
      active: false
    },
    {
      label: 'stickywilds',
      active: false
    },
    {
      label: 'megaways',
      active: false
    },
    {
      label: 'classic',
      active: false
    },
    {
      label: 'fun',
      active: false
    },
    {
      label: 'providers',
      active: false
    }
  ]
};
